// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Batch memo'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li ng-class="{'active': \$ctrl.displayMode === 'CREDIT'}">
        <a data-target="#tab-credit-memo" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('CREDIT')">
          <span>Credit</span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'DEBIT'}">
        <a data-target="#tab-debit-memo" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('DEBIT')">
          <span>Debit</span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'HISTORY'}">
        <a data-target="#tab-debit-memo" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('HISTORY')">
          <span>History</span>
        </a>
      </li>
    </ul>
  </div>

  <div ng-if="\$ctrl.displayMode !== 'HISTORY'" class="tab-content">
    <form name="\$ctrl.memoForm" novalidate>
      <div class="form-column">
        <form-section-field field-title="'Category'">
          <gl-category-select
            required
            action-type="\$ctrl.displayMode === 'CREDIT' ? 'ACCOUNT_BATCH_MEMO_CREDIT' : 'ACCOUNT_BATCH_MEMO_DEBIT'"
            single-accounts-only="true"
            is-selectize="true"
            ng-model="\$ctrl.category"
            ng-change="\$ctrl.onCategoryChange()"
          >
          </gl-category-select>
        </form-section-field>
        <form-section-field field-title="'Remarks'">
          <input required type="text" ng-model="\$ctrl.remarks">
        </form-section-field>
        <form-section-field field-title="'Tag type'">
          <select class="tag-type-input"
                  name="tagTypes"
                  ng-model="\$ctrl.tagType"
                  ng-options="type.value as type.label for type in \$ctrl.tagTypes"
                  required>
          </select>
          <help class="tag-type-input__label"
                title="Determine whether to process Regular memo (default behavior) or Tagged memo. Select None for regular memo otherwise it will process tagged memo with the selected tag type">
          </help>
        </form-section-field>
        <form-section-field field-title="'Allow transactions on non-active accounts'">
          <input type="checkbox" ng-model="\$ctrl.allowNonActiveAccounts">
        </form-section-field>
        <form-section-field field-title="'Data source'">
          <select name="dataSource"
                  ng-model="\$ctrl.dataSource"
                  ng-change="\$ctrl.onDataSourceChange()"
                  ng-options="type.value as type.label for type in \$ctrl.dataSourceTypes"
                  required>
          </select>
        </form-section-field>
        <form-section-field field-title="'CSV Separator'" ng-if="!\$ctrl.isManualDataSourceTypeSelected()">
          <select name="csvSeparator"
                  ng-model="\$ctrl.selectedCsvSeparator"
                  ng-options="csvSeparator.value as csvSeparator.label for csvSeparator in \$ctrl.csvSeparators"
                  required>
          </select>
        </form-section-field>
        <form-section-field ng-if="!\$ctrl.isManualDataSourceTypeSelected()">
          <file-upload
            ng-model="\$ctrl.fileContent"
            validate='{pattern: "*.csv"}'
            max-files="1"
            show-file-name="true"
            show-remarks="false"
            enable-webcam="false">
          </file-upload>
        </form-section-field>
      </div>

      <gl-category-input
        ng-if="\$ctrl.isManualDataSourceTypeSelected()"
        units="\$ctrl.categoryUnits"
        disable-amount="true">
      </gl-category-input>

      <table class="table" ng-if="\$ctrl.isManualDataSourceTypeSelected()">
        <thead>
        <tr>
          <th class="th--index">#</th>
          <th>Account number</th>
          <th>Extra number</th>
          <th>Amount</th>
          <th>Remarks</th>
          <th>Actions</th>
        </tr>
        </thead>

        <tbody class="tbody">
        <tr ng-repeat="entry in \$ctrl.memoEntries">
          <td>{{\$index + 1}}.</td>
          <td>{{entry.productNumber}}</td>
          <td>{{entry.extraNumber}}</td>
          <td>
            <cash ng-model="entry.amount"
                  ng-required="true"
                  min="0.01"
                  ng-change="\$ctrl.updateTotal()"></cash>
          </td>
          <td>
            <input type="text" maxlength="256" ng-model="entry.remarks">
          </td>
          <td class="table__actions">
            <a class="btn btn-danger" ng-click="\$ctrl.removeMemoEntry(\$index)">Remove</a>
          </td>
        </tr>
        </tbody>

        <tfoot>
        <tr>
          <td class="text-right" colspan="3">Summary:</td>
          <td>
            <cash ng-model="\$ctrl.total" ng-disabled="true"></cash>
          </td>
          <td class="text-right" colspan="2"></td>
        </tr>
        <tr>
          <td colspan="6"></td>
        </tr>
        </tfoot>
      </table>

      <account-picker ng-if="\$ctrl.isManualDataSourceTypeSelected()"
                      on-choose="\$ctrl.addMemoEntry(account)">
      </account-picker>

      <div class="buttons">
        <button type="button"
                class="btn btn-warning"
                ng-click="\$ctrl.resetAll()">
          Cancel
        </button>
        <button type="button"
                class="btn btn-success"
                ng-click="\$ctrl.doOperation()"
                ng-disabled="\$ctrl.memoForm.\$invalid">
          Perform
        </button>

        <validator condition="\$ctrl.fileContent.length === 1 || \$ctrl.memoEntries.length > 0"></validator>
      </div>
    </form>
  </div>

  <div ng-if="\$ctrl.displayMode === 'HISTORY'">
    <batch-memo-history></batch-memo-history>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/memo/batch-memo.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;